export const LOGO_AND_TEXT_QUERY = 'logoAndText';
export const CHECKER_QUERY = 'checker';
export const HEADER_QUERY = 'header';
export const NOT_DISPLAY_VALUE = 'off';
